import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./HeaderSliderCard.module.scss";
import { usePopup } from "@/context/PopupContext";

interface HeaderSliderCardProps {
  imageSrc1920: string;
  imageSrc1440: string;
  imageSrc768: string;
  imageSrc320: string;
  alt?: string;
  imageType: "full" | "partial";
  className?: string;
}

const HeaderSliderCard: React.FC<HeaderSliderCardProps> = ({
  imageSrc1920,
  imageSrc1440,
  imageSrc768,
  alt,
  imageType,
  className,
}) => {
  const { t } = useTranslation("common");
  const { openMenu } = usePopup();

  const imageClass = `${imageType}`;
  const displayAlt = alt || t("headerSlider.slideAlt");

  return (
    <div
      className={`${styles.card} ${className ? styles[className] : ""}`}
      role="figure"
      aria-label={displayAlt}
    >
      <picture className={styles[imageClass]}>
        {/* WebP версии */}
        <source
          media="(max-width: 768px)"
          srcSet={`${imageSrc768.replace(
            ".png",
            ".webp"
          )} 768w, ${imageSrc1440.replace(".png", ".webp")} 1440w`}
          type="image/webp"
        />
        <source
          media="(max-width: 1024px)"
          srcSet={`${imageSrc1440.replace(
            ".png",
            ".webp"
          )} 1440w, ${imageSrc1920.replace(".png", ".webp")} 1920w`}
          type="image/webp"
        />
        <source
          srcSet={`${imageSrc1440.replace(
            ".png",
            ".webp"
          )} 1440w, ${imageSrc1920.replace(".png", ".webp")} 1920w`}
          type="image/webp"
        />
        {/* PNG версии */}
        <source
          media="(max-width: 768px)"
          srcSet={`${imageSrc768} 768w, ${imageSrc1440} 1440w`}
          type="image/png"
        />
        <source
          media="(max-width: 1024px)"
          srcSet={`${imageSrc1440} 1440w, ${imageSrc1920} 1920w`}
          type="image/png"
        />
        {/* Fallback */}
        <img
          src={imageSrc1920}
          srcSet={`${imageSrc768} 768w, ${imageSrc1440} 1440w, ${imageSrc1920} 1920w`}
          sizes="(max-width: 768px) 768px, (max-width: 1024px) 1440px, 1920px"
          alt={displayAlt}
          className={styles.cardImage}
        />
      </picture>
      <div className={styles.overlay}></div>
      <div className={`container sideP88 ${styles.sliderCont}`}>
        <div className={styles.leftBlock}>
          <h1>{t("headerSlider.title")}</h1>
        </div>
        <div className={styles.rightBlock}>
          <p>{t("headerSlider.description")}</p>
          <button
            className={`commonButton buttonLg ${styles.button}`}
            onClick={openMenu}
          >
            {t("headerSlider.button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderSliderCard;
